import React from 'react';
import { Avatar, List } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';

import { Business } from '@src/types';

type Props = {
  item: Business;
};

const Component: React.FC<Props> = ({ item }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    // @ts-ignore
    () => navigation.push('Location', { id: item.id }),
    [item.id, navigation]
  );

  return (
    <List.Item
      onPress={handlePress}
      title={item.name}
      left={(props) => (
        <Avatar.Icon {...props} icon="map-marker-alt" size={50} />
      )}
    />
  );
};

Component.displayName = 'BusinessCard';

export default React.memo(Component);
